var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2883 7.90723H10.5737V11.2875H13.2712V12.7028H10.5737V16.0828H12.3723C12.8344 16.0828 16.1662 16.135 16.1611 12.1502C16.1559 8.16535 12.9296 7.90723 12.2883 7.90723Z",
    fill: "#C2A633"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37252 0 0 5.37252 0 12C0 18.6275 5.37252 24 12 24C18.6275 24 24 18.6275 24 12C24 5.37252 18.6275 0 12 0ZM12.4715 18.4812H8.12568V12.7037H6.59376V11.2884H8.12556V5.51052H11.8554C12.7378 5.51052 18.5821 5.32728 18.5821 12.1043C18.5821 18.9934 12.4716 18.4812 12.4716 18.4812H12.4715Z",
    fill: "#C2A633"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoge);
export default __webpack_public_path__ + "static/media/doge.6a2f0f4488dd36ccbc9f086368ee5246.svg";
export { ForwardRef as ReactComponent };